import { Icon } from '@design/components/icon/Icon';
import { WithNAFallback } from '@design/components/table';
import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './EarningsReportingSummary.module.scss';
import type { GuidanceDirection } from './types';

interface GuidanceCellProps {
  guidance?: GuidanceDirection;
}

export const GuidanceCell = ({ guidance }: GuidanceCellProps) => {
  const { t } = useTranslation(['widget']);

  if (!guidance) {
    return (
      <div className={styles.notAvailableValue}>
        <WithNAFallback check={false} value={null} />
      </div>
    );
  }

  const isRaised = guidance === 'raised';

  return (
    <span
      className={clsx(styles.guidance, {
        [semanticColorStyles.directionPositive]: isRaised,
        [semanticColorStyles.directionNegative]: !isRaised,
      })}
    >
      <Icon
        iconName={isRaised ? 'GuidanceUp' : 'GuidanceDown'}
        size={12}
        fillColor={isRaised ? 'var(--viz-bullish)' : 'var(--viz-bearish)'}
      />
      {t(
        isRaised
          ? 'widget:themeOverview.tabs.earnings.reportingSummary.guidanceRaised'
          : 'widget:themeOverview.tabs.earnings.reportingSummary.guidanceLowered'
      )}
    </span>
  );
};
